import { useEffect } from 'react';
import { KeyboardBackspace } from '@mui/icons-material';
import AddRequestSidebar from 'components/client-pool/AddRequestSidebar';
import { useNavigate } from 'react-router-dom';
import useUserStore from 'store/useUserStore';
import { ROUTES } from 'util/Constants';

export default function AddRequest() {
    const navigate = useNavigate();
    const { userInfo } = useUserStore();

    // Route protection: redirect non-business users to overview page
    useEffect(() => {
        if (userInfo?.accountType !== 'business') {
            navigate(ROUTES.MAIN, { replace: true });
        }
    }, [userInfo?.accountType, navigate]);

    // Don't render the component for non-business users while redirect is happening
    if (userInfo?.accountType !== 'business') {
        return null;
    }

    return (
        <div className="h-screen overflow-hidden">
            <div className="flex gap-2 bg-white py-4 lg:pl-12 pl-8 cursor-pointer border border-gray-300" onClick={() => navigate(ROUTES.MAIN)}>
                <KeyboardBackspace />
                Back To Dashboard
            </div>
            {/* Sidebar */}
            <AddRequestSidebar />
        </div>
    );
}
